module.exports = __webpack_public_path__ + "static/media/pack-ur-bags-logo-bw.17529e02.png";